module.exports = __webpack_public_path__ + "static/img/萌小乖.5e44e82e.png";